import { MaterialIcon } from "@website/icons/material";
import { useTabBar } from "@website/ui/tab-bar/tab-bar.hook";
import styles from "@website/ui/tab-bar/tab-bar.module.scss";
import { TabBarPropertiesType } from "@website/ui/tab-bar/tab-bar.types";
import { TabButton } from "@website/ui/tab-button";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const TabBar: FC<TabBarPropertiesType> = (properties) => {
  const {
    "aria-label": ariaLabel,
    className,
    color = "primary",
    variant = "contained",
    iconPosition = "top",
    orientation = "horizontal",
    behavior = "button",
    size = "content",
    tabs,
    value
  } = properties;

  const { buttonsContainerProps, nextScrollProps, previousScrollProps } =
    useTabBar(properties);

  return (
    <div
      className={`${styles["tab-bar"]} ${styles[orientation]} ${
        styles[color]
      } ${styles[variant]} ${className ?? ""}`}
    >
      <div {...previousScrollProps} className={styles["nav-button"]}>
        <MaterialIcon
          className={styles["nav-button-icon"]}
          name="arrow_back_ios"
          variant="outlined"
        />
      </div>
      <div
        {...buttonsContainerProps}
        aria-label={ariaLabel}
        className={styles["buttons-container"]}
        role="tablist"
      >
        {tabs.map((item, index) => (
          <TabButton
            Icon={item.Icon}
            Wrapper={item.Wrapper}
            badge={item.badge}
            behavior={behavior}
            color={color}
            description={item.description}
            disabled={item.disabled}
            href={item.href}
            iconPosition={iconPosition}
            index={index}
            key={item.title}
            onClick={item.onClick}
            selected={value === index}
            size={size}
            title={item.title}
            variant={variant}
          />
        ))}
      </div>
      <div {...nextScrollProps} className={styles["nav-button"]}>
        <MaterialIcon
          className={styles["nav-button-icon"]}
          name="arrow_forward_ios"
          variant="outlined"
        />
      </div>
    </div>
  );
};

const TabBarMemoized = memo(TabBar, deepCompare);
export { TabBarMemoized as TabBar };
